import localforage from "localforage";
import { create } from "zustand";
import { toast } from "~served/ui-comps/toast";
import { STORAGE_KEYS } from "~/libs/storage-keys";

interface CustomerSessionState {
	tokens: Record<string, string | null | undefined>;
	loading: Record<string, boolean>;
	hydrate: (venueId: string) => Promise<void>;
	setToken: (venueId: string, token: string | null) => void;
}

export const useCustomerSessionStore = create<CustomerSessionState>(
	(set, get) => ({
		tokens: {},
		loading: {},
		hydrate: async (venueId) => {
			const state = get();
			if (state.tokens[venueId] !== undefined || state.loading[venueId]) return;
			set({ loading: { ...state.loading, [venueId]: true } });
			const token = await localforage
				.getItem<string>(STORAGE_KEYS.CUSTOMER_TOKEN(venueId))
				.catch(() => {
					toast.error("Unable to restore your sign-in. Please sign in again.");
					return null;
				});
			set((current) => ({
				tokens:
					current.tokens[venueId] === undefined
						? { ...current.tokens, [venueId]: token }
						: current.tokens,
				loading: { ...current.loading, [venueId]: false },
			}));
		},
		setToken: (venueId, token) =>
			set((state) => ({ tokens: { ...state.tokens, [venueId]: token } })),
	}),
);
